var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoFlag = function SvgIcoFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M1 0a1 1 0 0 0-1 1v18a1 1 0 1 0 2 0v-7.536Q4.536 12 6 12c1 0 1.75-.25 2.5-.5S10 11 11 11q1.56 0 3.73.609a1 1 0 0 0 1.27-.963V2.73a1 1 0 0 0-.708-.956Q12.76 1 11 1c-1 0-1.75.25-2.5.5S7 2 6 2q-1.465 0-4-.536V1a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIcoFlag;